/**
 * Custom cart update handler for header-raw.liquid
 * Only updates the cart count instead of replacing the entire element
 */
class HeaderRawCart {
  constructor() {
    this.cartIconBubble = document.querySelector('#cart-icon-bubble-raw');
    this.hiddenCartIcon = document.querySelector('#cart-icon-bubble');
    this.setupListeners();
    this.initCartCount();
  }

  setupListeners() {
    // Listen for cart updates from the Shopify PubSub system
    if (typeof window.PUB_SUB_EVENTS !== 'undefined') {
      const cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        this.updateCartCount(event.cartData.item_count);
      });
    }

    // Also observe mutations to the hidden cart icon element
    // This handles cases where the cart is updated through other means
    if (this.hiddenCartIcon) {
      const observer = new MutationObserver((mutations) => {
        // After the hidden cart icon is updated, update our visible cart icon
        this.updateCartCountFromDOM();
      });

      observer.observe(this.hiddenCartIcon, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    // Set up click handler for cart icon
    if (this.cartIconBubble) {
      this.cartIconBubble.addEventListener('click', (event) => {
        event.preventDefault();

        // If we're using cart drawer, trigger it
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.open();
          return;
        }

        // Otherwise, navigate to cart page
        window.location.href = window.routes.cart_url;
      });
    }
  }

  // Initialize cart count from the current cart
  async initCartCount() {
    // First try to get from window.cart if available
    if (window.cart?.item_count !== undefined) {
      this.updateCartCount(window.cart.item_count);
      return;
    }

    // Otherwise fetch from Shopify API
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      this.updateCartCount(cart.item_count || 0);
    } catch (error) {
      console.error('Failed to fetch cart:', error);
      // Fall back to parsing the DOM if API fails
      const cartElement = document.querySelector('#cart-icon-bubble-raw');
      if (cartElement) {
        const match = cartElement.textContent.match(/CART\((\d+)\)/);
        if (match) {
          this.updateCartCount(parseInt(match[1], 10));
        }
      }
    }
  }

  // Update from the hidden cart icon that gets updated by Shopify
  updateCartCountFromDOM() {
    if (!this.hiddenCartIcon) return;

    // Look for cart count bubble inside the hidden element
    const cartCountBubble = this.hiddenCartIcon.querySelector('.cart-count-bubble');
    let count = 0;

    if (cartCountBubble) {
      // Get the count from the cart count bubble
      const countText = cartCountBubble.querySelector('span[aria-hidden="true"]')?.textContent;
      count = parseInt(countText || '0', 10);
    }

    this.updateCartCount(count);
  }

  // Update just the text content of the cart button, not the whole element
  updateCartCount(count) {
    if (!this.cartIconBubble) return;

    const newText = `CART(${count || 0})`;

    // Only update the text content, preserving the element and its styling
    this.cartIconBubble.textContent = newText;
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.header-raw')) {
    new HeaderRawCart();
  }
});
